import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  type CreateSegmentRequest,
  segmentsApi,
} from '@/api/segments/segmentsApi'
import { segmentsQueries } from '@/api/segments/segmentsQueries'

export const useCreateSegmentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateSegmentRequest) =>
      segmentsApi.createSegment(payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: segmentsQueries.all() }),
  })
}
